import styled from 'styled-components'

export const Container = styled.div`
    padding: 1rem 0 0 0;
    height: 100%;
    width: 100%;

    display: flex;
    flex-direction: column;

    .backToMenu{
        color: #FFF;
        
        border: none;
        background: #7A05A7;
        padding: 0.5rem;
        border-radius: 5px;
        width: max-content;

        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
    }
`